<template>
    <div class="title">
        <h1>Виселица</h1>
    </div>
    <div class="logo">
        <img src="../assets/img/logo.jpg" alt="logo">
    </div>

</template>

<script lang="ts" setup>

</script>

<style lang="sass" scoped>
@import '../assets/styles/main'
.title
    font-family: 'Pacifico-Regular'
    font-weight: 100
    font-size: 30px
    h1
        margin: 0px
        padding: 0px
.logo
    display: flex

img
    height: 100px
    width: 200px

</style>
